import authManage from "@/middlewares/manage/auth";
import domain from "@/middlewares/manage/domain";
import selectOrganization from "@/middlewares/manage/select-organization";

export default {
  path: "billing-addresses",
  name: "BillingAddressManage",
  component: () =>
    import(
      /* webpackChunkName: "billing-address-manage-layout-view" */ "@/views/Manage/BillingAddress/LayoutView.vue"
    ),
  redirect: { name: "BillingAddressSearch" },
  children: [
    {
      path: "",
      name: "BillingAddressSearch",
      component: () =>
        import(
          /* webpackChunkName: "billing-address-manage-searching-view" */ "@/views/Manage/BillingAddress/Search.vue"
        ),
      meta: {
        middleware: [domain, authManage, selectOrganization],
      },
    },
    {
      path: "create/:code", // /manage/billing-addresses/create/1
      name: "BillingAddressCreate",
      component: () =>
        import(
          /* webpackChunkName: "billing-address-manage-create-view" */ "@/views/Manage/BillingAddress/Create.vue"
        ),
      meta: {
        middleware: [domain, authManage, selectOrganization],
      },
    },
    {
      path: "edit/:code/:id", // /manage/billing-addresses/edit/1/2
      name: "BillingAddressEdit",
      component: () =>
        import(
          /* webpackChunkName: "billing-address-manage-edit-view" */ "@/views/Manage/BillingAddress/Edit.vue"
        ),
      meta: {
        middleware: [domain, authManage, selectOrganization],
      },
    },
    {
      path: "get-list/:code", // /manage/billing-addresses/edit/1/2
      name: "BillingAddressDetail",
      component: () =>
        import(
          /* webpackChunkName: "billing-address-manage-detail-view" */ "@/views/Manage/BillingAddress/Detail.vue"
        ),
      meta: {
        middleware: [domain, authManage, selectOrganization],
      },
    },
  ],
};
